import script from "./MainRelatorios.vue?vue&type=script&setup=true&lang=js"
export * from "./MainRelatorios.vue?vue&type=script&setup=true&lang=js"

import "./MainRelatorios.vue?vue&type=style&index=0&id=1e76f0f4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e76f0f4"]])

export default __exports__
import QSkeleton from 'quasar/src/components/skeleton/QSkeleton.js';
import QTabs from 'quasar/src/components/tabs/QTabs.js';
import QTab from 'quasar/src/components/tabs/QTab.js';
import QTabPanels from 'quasar/src/components/tab-panels/QTabPanels.js';
import QTabPanel from 'quasar/src/components/tab-panels/QTabPanel.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QLinearProgress from 'quasar/src/components/linear-progress/QLinearProgress.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSkeleton,QTabs,QTab,QTabPanels,QTabPanel,QIcon,QLinearProgress,QTable,QSelect});
